module.exports = __webpack_public_path__ + "img/tablet-neck-14_36x292.6c265855.png";